<template>
  <div
    v-for="x in parseInt(count)"
    :key="x"
    class="card card-list"
  >
    <div class="card-row">
      <h3
        style="margin-bottom: 0;"
        class="loading-text"
      >
        Payment Product
      </h3>
    </div>
    <div class="card-row">
      <ul>
        <li><span class="loading-text">Loading academicYear</span></li>
        <li><span class="loading-text">Loading escudos</span></li>
        <li><span class="loading-text">Loading euros</span></li>
        <li><span class="loading-text">Loading credit</span></li>
        <li><span class="loading-text">Loading restitution</span></li>
        <li><span class="loading-text">Loading releaseDate</span></li>
        <li><span class="loading-text">Loading paymentDate</span></li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    count: {
      type: Number,
      required: true,
      validator: prop => Number.isInteger(prop) & prop > 0
    }
  }
}
</script>
